import React from 'react';
import { Globe } from 'lucide-react';
import ServiceHeader from '../../components/services/ServiceHeader';
import ServiceFeatureCard from '../../components/ui/ServiceFeatureCard';
import { colors } from '../../styles/theme';
import ServiceSteps from '../../components/services/sections/ServiceSteps';

const features = [
  {
    iconName: "Server",
    title: "Espace SSD NVMe",
    description: "100 Go d'espace de stockage ultra-rapide"
  },
  {
    iconName: "Database",
    title: "Bases de données",
    description: "MySQL, PostgreSQL et MongoDB inclus"
  },
  {
    iconName: "Code",
    title: "Technologies",
    description: "PHP, Node.js, Python et plus encore"
  },
  {
    iconName: "Shield",
    title: "SSL Gratuit",
    description: "Certificats Let's Encrypt automatiques"
  },
  {
    iconName: "Zap",
    title: "Performance",
    description: "Serveurs optimisés et CDN inclus"
  },
  {
    iconName: "Clock",
    title: "Sauvegarde",
    description: "Backups quotidiens automatiques"
  }
];

const steps = [
  {
    title: "Inscrivez-vous sur FRANCE STUDENT",
    description: "Créez votre compte étudiant en quelques clics"
  },
  {
    title: "Vérifiez votre statut étudiant",
    description: "Téléchargez votre carte étudiante ou certificat de scolarité"
  },
  {
    title: "Commandez votre hébergement",
    description: "Choississez votre nom de domaine et déployez votre site web !"
  }
];

const HebergementPage = () => {
  const handleOrder = () => {
    window.location.href = 'https://my.francestudent.org/store/web';
  };
  return (
    <div>
      <ServiceHeader
        title="Hébergement Web"
        description="Un hébergement web haute performance pour vos projets, avec toutes les technologies modernes incluses."
        icon={<Globe className="w-8 h-8 text-white" />}
        color={colors.tertiary}
        imageUrl="https://i.imgur.com/j2t4g6i.jpeg"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Caractéristiques */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <ServiceFeatureCard
              key={index}
              iconName={feature.iconName}
              title={feature.title}
              description={feature.description}
              color={colors.tertiary}
            />
          ))}
        </div>

        {/* Spécifications techniques */}
        <section className="mt-16">
          <h2 className="text-2xl font-bold mb-8">Spécifications Techniques</h2>
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="font-semibold mb-4">Infrastructure</h3>
                <ul className="space-y-3 text-gray-600">
                  <li>• Serveurs dernière génération</li>
                  <li>• Disques SSD NVMe en RAID</li>
                  <li>• Bande passante illimitée</li>
                  <li>• Protection DDoS incluse</li>
                  <li>• Datacenters en France</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold mb-4">Technologies Supportées</h3>
                <ul className="space-y-3 text-gray-600">
                  <li>• PHP 7.4, 8.0, 8.1, 8.2</li>
                  <li>• Node.js 14, 16, 18, 20</li>
                  <li>• Python 3.8, 3.9, 3.10, 3.11</li>
                  <li>• Ruby, Perl, Java</li>
                  <li>• SSH et SFTP inclus</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <div class="pt-11">
          <ServiceSteps
                title="Comment en Bénéficier"
                steps={steps}
                color={colors.tertiary}
                ctaText="Activer mon hébergement web"
                onCtaClick={handleOrder}
          />
        </div>
      </div>
    </div>
  );
};

export default HebergementPage;